module.exports = __webpack_public_path__ + "gs.svg?21f7c99f17bb19ebe4b9921b7fa01afc";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/gs.svg
// module id = 1133
// module chunks = 0